
import { BaseAppConfig } from 'lib-customizations/types'

import { env, Env } from './env'

type AppConfigs = {
  default: BaseAppConfig
} & {
  [k in Env]: BaseAppConfig
}

const employeeConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://c2311165402c46e5a4bde4b2d0031da2@sentry.haltu.net/37',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://c2311165402c46e5a4bde4b2d0031da2@sentry.haltu.net/37',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://c2311165402c46e5a4bde4b2d0031da2@sentry.haltu.net/37',
      enabled: true,
    },
  },
}

const employeeMobileConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://c2311165402c46e5a4bde4b2d0031da2@sentry.haltu.net/37',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://c2311165402c46e5a4bde4b2d0031da2@sentry.haltu.net/37',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://c2311165402c46e5a4bde4b2d0031da2@sentry.haltu.net/37',
      enabled: true,
    },
  },
}

const citizenConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://c2311165402c46e5a4bde4b2d0031da2@sentry.haltu.net/37',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://c2311165402c46e5a4bde4b2d0031da2@sentry.haltu.net/37',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://c2311165402c46e5a4bde4b2d0031da2@sentry.haltu.net/37',
      enabled: true,
    },
  },
}

const employeeConfig = employeeConfigs[env()]
const employeeMobileConfig = employeeMobileConfigs[env()]
const citizenConfig = citizenConfigs[env()]

export { employeeConfig, employeeMobileConfig, citizenConfig }
